export const getEllipsisStyles = (maxWidth: string | number) => ({
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth,
});
